'use strict';

angular.module('app', ['ngRoute', 'ui.utils.masks', 'idf.br-filters']);
